import { AuthModal } from '@zoopla/authentication/modal';
import { SaveThisSearchModal } from './SaveThisSearchModal';
import { UseSaveThisSearchModal } from './useSaveThisSearchModal';

type SaveThisSearchModalWithAuthProps = UseSaveThisSearchModal;

export const SaveThisSearchModalWithAuth = ({
    showAuthModal,
    setShowAuthModal,
    defaultAlertFrequency,
    showSaveThisSearchModal,
    setShowSaveThisSearchModal
}: SaveThisSearchModalWithAuthProps) => {
    return (
        <>
            <AuthModal
                actionAfterAuth={{
                    action: () => {
                        setShowSaveThisSearchModal(true);
                    },
                    eventLabel:
                        defaultAlertFrequency === ''
                            ? 'save_search'
                            : 'create_alert'
                }}
                close={() => {
                    setShowAuthModal(false);
                }}
                initialMode="sign-in"
                isShowing={showAuthModal}
            />

            <SaveThisSearchModal
                defaultAlertFrequency={defaultAlertFrequency}
                isOpen={showSaveThisSearchModal}
                onOpenChange={setShowSaveThisSearchModal}
            />
        </>
    );
};
